import {AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, ViewChild} from "@angular/core";
import {ModalDirective} from 'ngx-bootstrap';
import {UserService} from '../../services/user.service';
import {EndpointsService} from '../../services/endpoints.service';
import {HttpApiService} from '../../services/http-api.service';
import {FileResult} from '../../directives/file-result.interface';
import {Constants} from '../../services/constants';
import {AlertMessageComponent, AlertType} from '../alert-message/alert-message.component';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file-model.component.html'
})
export class UploadFileModelComponent implements AfterViewInit, OnChanges {

  @Input() public title = '';
  @Input() public data: any = {};
  @ViewChild('updateLeadModal') public modal: ModalDirective;
  @Output() public onHide: EventEmitter<any> = new EventEmitter();
  isUpdating: boolean;
  updating = false;
  successMessage = '';
  selectedStatus: string;
  reason: string;
  errorMessage: string;
  fileData: any = {fileName: '', data: '', profileId: ''};
  uploadData = {leadId: '', information: '', fileName: '', data: '',
    isRfq: false, rfqId: '', messageOwner: '', isUploadFile: true};

  infoMessage = '';
  constructor(private userService: UserService,
              private endpoints: EndpointsService,
              private api: HttpApiService) {
  }

  ngAfterViewInit() {
    this.modal.onHide.subscribe(() => {
      this.resetValues();
      this.onHide.emit(true);
    });
  }

  ngOnChanges(changes: any): void {
    if (changes.data && changes.data.currentValue) {
      this.selectedStatus = this.data.vendorApprovalStatus;
      this.showModal();
    }
  }


  onProgramTerm(fileResult: FileResult, uploadFileData) {
    if (fileResult.dataURL) {
      const fileName = `${fileResult.file.name.substring(0,
        fileResult.file.name.lastIndexOf('.'))}-${Date.now()}.pdf`;
      this.fileData.fileName = fileName;
      this.fileData.data = fileResult.dataURL;
     // this.uploadTermAndConditionFile(this.fileData, uploadFileData);
    }
  }
  uploadTermAndConditionFile(data: any, uploadFileData) {
    this.api.put(this.endpoints.getUploadFileUrl('tenantId=' + Constants.TENANT_ID()),
      data, true)
      .subscribe(response => {
        this.uploadData = response;
        this.isUpdating = false;
      }, er => {
        AlertMessageComponent.open(AlertType.Error, 'File uploading failure');
      });
  }

  public showModal(): void {
    this.modal.config.backdrop = false;
    this.modal.show();
  }

  public hideModal(): void {
    this.modal.hide();
  }

  private resetValues() {
    this.selectedStatus = null;
    this.reason = null;
    this.errorMessage = null;
  }

  get isSuperAdmin() {
    return this.userService.isSuperAdmin();
  }

  get isVendor() {
    return this.userService.isVendor();
  }

  uploadFile() {
    if (this.data.isRfq) {
      this.uploadData.rfqId = this.data.id;
    } else {
      this.uploadData.leadId = this.data.id;
    }

    if (this.userService.isVendor()) {
      this.uploadData.messageOwner = 'VENDOR';
    } else if (this.userService.isReseller()) {
      this.uploadData.messageOwner = 'RESELLER';
    }else if (this.userService.isBuyer()) {
      this.uploadData.messageOwner = 'BUYER';
    }

    if (this.fileData.fileName !== '' || this.infoMessage !== '') {
      this.isUpdating = true;
      this.uploadData.isUploadFile = true;
      this.uploadData.information = this.infoMessage;
      this.uploadData.fileName = this.fileData.fileName;
      this.uploadData.data = this.fileData.data;
      this.api.post(this.endpoints.getLeadUrl() + '/upload-information',
        this.uploadData, true)
        .subscribe(result => {
          this.isUpdating = false;
          this.fileData.fileName = '';
          this.infoMessage = '';
          AlertMessageComponent.open(AlertType.Success, 'Information uploaded Successfully');
          this.hideModal();
        }, er => {
          this.isUpdating = false;
          AlertMessageComponent.open(AlertType.Error, 'Information uploading failure');
          this.hideModal();
        });
    }else {
      AlertMessageComponent.open(AlertType.Error, 'Please enter your message first');
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/upload-file/upload-file-model.component.ts